import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    overflow-y: auto;
    padding: 28px 20px 24px;
    gap: 16px;
`;

export const IntroSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 26px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    margin: 0;
    text-align: center;
    line-height: 1.3;
`;

export const Subtitle = styled.p`
    font-size: 14px;
    color: #444;
    margin: 0;
    line-height: 1.6;
`;

export const DocumentInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    width: 100%;
`;

export const CounterRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
`;

export const NavButton = styled.button<{ $color: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid ${({ $color }) => $color};
    background-color: #ffffff;
    color: ${({ $color }) => $color};
    cursor: pointer;
    flex-shrink: 0;
    transition: opacity 0.2s;

    &:disabled {
        border-color: #e2e8f0;
        color: #cbd5e0;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        opacity: 0.85;
    }
`;

export const Counter = styled.span<{ $color: string }>`
    font-size: 13px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    background-color: ${({ $color }) => `${$color}1a`};
    padding: 4px 12px;
    border-radius: 999px;
`;

export const DocumentName = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #1a202c;
    line-height: 1.4;
    text-align: center;
    word-break: break-word;
`;

export const ViewerContainer = styled.div`
    flex: 1;
    width: 100%;
    min-height: 0;
    background-color: #f5f7fa;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const FallbackBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 24px;
    color: #4a5568;
    font-size: 14px;
    font-weight: 600;
`;

export const DocumentNameList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const DocumentNameItem = styled.li`
    font-size: 14px;
    color: #1a202c;
    padding: 12px 16px;
    background-color: #f5f5f5;
    border-radius: 8px;
    word-break: break-word;
`;

export const HintText = styled.p`
    font-size: 13px;
    color: #718096;
    margin: 0;
    text-align: center;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const FooterCheckbox = styled.div`
    width: 100%;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 20px;
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    flex-shrink: 0;
`;

export const SubmitButton = styled.button<{ $backgroundColor: string; $disabled: boolean }>`
    width: 100%;
    padding: 16px 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: ${({ $backgroundColor, $disabled }) => ($disabled ? '#aaa' : $backgroundColor)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

export const OutlineButton = styled.button<{ $color: string }>`
    width: 100%;
    padding: 15px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    background-color: ${({ $color }) => `${$color}33`};
    border: 1px solid ${({ $color }) => $color};
    color: ${({ $color }) => $color};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.85;
    }
`;
